import { aiEmployeePromoRoute } from './aiEmployeePromo'
import { aiEvaluationsRoute } from './aiEvaluations'
import { analyticsRoute } from './analytics'
import { automationRoutes } from './automation'
import { blogsRoutes } from './blogs'
import { businessRoute } from './business'
import { calendarRoutes } from './calendars'
import { contactRoutes } from './contact'
import { contactsRoutes } from './contacts'
import { conversationRoute } from './conversations'
import { copilotRoute } from './copilot'
import { customMenuLinkRoute } from './customMenuLink'
import { customObjectsRoutes } from './customObjects'
import { customPageLinkRoute } from './customPageLink'
import { DashboardRoute } from './dashboard'
import { DocumentsContractsTemplateListRoute } from './documents-contracts/document-contracts-template-list'
import { DocumentsContractsBuilderRoute } from './documents-contracts/documents-contracts-builder'
import { DocumentsContractsListRoute } from './documents-contracts/documents-contracts-list'
import { DocumentsContractsTemplateBuilderRoute } from './documents-contracts/documents-contracts-template-builder'
import { DocumentsContractsBuilderPreviewRoute } from './documents-contracts/document-contracts-builder-preview'
import { FormBuilderRoutes } from './form-builder'
import { FunnelWebsiteRoute } from './funnel-websites'
import { integrationsRoute } from './integrations'
import { launchPadRoute } from './launchpad'
import { marketingRoute } from './marketing'
import { membershipRoutes } from './membership'
import { mobileAppRoute } from './mobileApp'
import { notificationsRoute } from './notifications'
import { opportunitiesRoute } from './opportunities'
import { estimatesRoutes } from './payment-products/estimates'
import { invoicesRoutes } from './payment-products/invoices'
import { invoicesIntegrationsRoutes } from './payment-products/invoices-integrations'
import { paymentLinksRoutes } from './payment-products/payment-links'
import { PaymentsRoute } from './payments'
import { CouponsRoute } from './payments/coupons'
import { GiftCardsRoute } from './payments/gift-cards'
import { PaymentIntegrationsRoute } from './payments/integrations'
import { OrdersRoute } from './payments/orders'
import { SubscriptionsRoute } from './payments/subscriptions'
import { TransactionsRoute } from './payments/transactions'
import { paymentSetupRoute } from './paymentSetup'
import { InventoryRoute } from './products/inventory'
import { ProductRoute } from './products/products'
import { QuizBuilderRoutes } from './quiz'
import { remindersRoute } from './reminders'
import { reportingRoute } from './reporting'
import { reputationRoutes } from './reputation'
import { restrictedRoute } from './restricted'
import { seoRoute } from './seo'
import { AbandonedCheckoutsRoute } from './stores/abandoned-checkout'
import { SurveyBuilderRoutes } from './survey-builder'
import { suspendedRoute } from './suspended'
import { tasksRoute } from './tasks'
import { verificationRoute } from './verification'

export const locationRoutes = [
  ...launchPadRoute,
  ...DashboardRoute,
  ...calendarRoutes,
  ...conversationRoute,
  ...customObjectsRoutes,
  ...reportingRoute,
  ...automationRoutes,
  ...opportunitiesRoute,
  ...membershipRoutes,
  ...contactsRoutes,
  ...contactRoutes,
  ...integrationsRoute,
  ...reputationRoutes,
  ...FunnelWebsiteRoute,
  ...marketingRoute,
  ...FormBuilderRoutes,
  ...SurveyBuilderRoutes,
  ...QuizBuilderRoutes,
  ...remindersRoute,
  ...notificationsRoute,
  ...verificationRoute,
  ...suspendedRoute,
  ...restrictedRoute,
  ...blogsRoutes,
  ...tasksRoute,
  ...businessRoute,
  ...customPageLinkRoute,
  ...customMenuLinkRoute,
  ...mobileAppRoute,
  ...analyticsRoute,
  ...aiEmployeePromoRoute,
  ...aiEvaluationsRoute,
  ...paymentSetupRoute,
  ...seoRoute,
  ...PaymentsRoute,
  ...TransactionsRoute,
  ...GiftCardsRoute,
  ...SubscriptionsRoute,
  ...CouponsRoute,
  ...OrdersRoute,
  ...PaymentIntegrationsRoute,
  ...paymentLinksRoutes,
  ...invoicesIntegrationsRoutes,
  ...estimatesRoutes,
  ...invoicesRoutes,
  ...DocumentsContractsListRoute,
  ...DocumentsContractsTemplateListRoute,
  ...DocumentsContractsBuilderRoute,
  ...DocumentsContractsBuilderPreviewRoute,
  ...DocumentsContractsTemplateBuilderRoute,
  ...ProductRoute,
  ...paymentSetupRoute,
  ...seoRoute,
  ...InventoryRoute,
  ...AbandonedCheckoutsRoute,
  ...copilotRoute,
]
